// @flow

import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormHelperText from '@material-ui/core/FormHelperText';
import { withStyles } from '@material-ui/core/styles';

type Props = {
    onLoginClick: Function,
    errorMessage: string,
    isFetching: boolean,
    classes: {
        root: string,
        cardActions: string
    }
}

type State = {
    username: string,
    password: string
};

const style = theme => ({
    root: {
        maxWidth: 500,
        margin: '0 auto'
    },
    cardActions: {
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    }
});

class Login extends Component<Props, State> {
    static defaultProps = {
        isFetching: false,
    };

    state = {
        username: '',
        password: '',
    };

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    login = (event) => {
        event.preventDefault();
        this.props.onLoginClick(this.state.username, this.state.password);
    };

    render() {
        return (
            <div className={this.props.classes.root}>
                <form onSubmit={this.login}>
                    <Card>
                        <CardHeader title="Login"/>
                        <CardContent>
                            <FormControl fullWidth margin="normal">
                                <InputLabel htmlFor="password">Email</InputLabel>
                                <Input
                                    id="username"
                                    name="username"
                                    value={this.state.username}
                                    onChange={this.handleChange}
                                    type="email"
                                />
                            </FormControl>
                            <FormControl fullWidth margin="normal">
                                <InputLabel htmlFor="password">Password</InputLabel>
                                <Input
                                    id="password"
                                    name="password"
                                    value={this.state.password}
                                    onChange={this.handleChange}
                                    type="password"
                                />
                            </FormControl>
                            {
                                this.props.errorMessage &&
                                <FormHelperText error id="login-error-message">
                                    {this.props.errorMessage}
                                </FormHelperText>
                            }
                        </CardContent>
                        <CardActions className={this.props.classes.cardActions}>
                            <Button variant="contained" color="primary" onSubmit={this.login} type="submit" id="login-button">
                                Login
                            </Button>
                            {
                                this.props.isFetching &&
                                <CircularProgress />
                            }
                        </CardActions>
                    </Card>
                </form>
            </div>
        );
    }
}

export default withStyles(style)(Login);
